import React from 'react';
import styled from 'styled-components';
import { BsDot } from "react-icons/bs";
import{ Link } from 'react-router-dom';

const TaskBox = styled.div`
    color:var(--gray);
    .taskLabel{
        font-weight:700;
        margin-bottom:0.5rem;
    }
    .taskAction{
        &>a{
            color:var(--gray);
        }
        font-weight:500;
            margin: 0 0 0.5rem 1rem;
        display:flex;
        align-items:center;
    }
    .taskAction:last-child{
        margin-bottom:2rem;

    }
    .notDispatched{
        margin-left:0.5rem;
        font-weight:700;
        color:var(--alert-color);
    }
    .supplementaryInfo{
        color:var(--light-gray);
    }
`;
// const MainLabel = styled.div`
//     font-weight:700;
//     margin-bottom:0.5rem;
// `;
// const SingleAction = styled.div`
//     margin: 0.5rem 0 1rem 1rem;
// `;
const addressFormats = {
    fullAddress: ['companyName', 'addressLine1', 'addressLine2', 'city', 'state', 'postalCode'],
    comCityState: ['companyName', 'city', 'state'],
    cityStatePost: ['city', 'state', 'postalCode'],
}
export function addressExtractor(address, addressType){
    if(address &&  Object.keys(address).length > 0){
        // let content = '';
        let noAddress = true;
        const format = addressFormats[addressType || "fullAddress"];
        
        
        for(let i = 0; i < format.length; i++){
            const val = address[format[i]];
            if(val !== null && val !== ''){
                noAddress = false;
                // if(inline)content += val + (format.length-1 > i ? (inline ? ', ' : `\n`) : '');
                // 
                break;
            }
        }
        // if(content === ''){
        if(noAddress){
            return null;
        }else{
            return address;
        }
    }else{
        return null;
    }
}
export const TaskListView = ({tasks}) => {
    return <div style={{marginTop:"2rem"}}>
        {tasks ? tasks.map((value, index) => {
            const address = addressExtractor(value.address, 'comCityState');
            
            return <TaskBox key={index} >
                <div className="taskLabel" >{address ? formattedAddress(address) : "Address Not Specified"} : {value.loadId === null && (value.apptDate || value.apptTime)?<span className="supplementaryInfo">{value.apptDate ? value.apptDate.substr(0, 5) : null} {value.apptTime ? value.apptTime : ''}</span>:null}</div>
                
                {value.actions.map((action, index)=>{
                    if(action.loadAction){
                        return <div className="taskAction" key={index}>
                            <BsDot />
                            <Link to={'loads/'+value.loadId}>{action.title}</Link>
                            {`: ${value.apptDate.substr(0, 5)} ${value.apptTime?value.apptTime:''} (${action.desc.toUpperCase()})`} 
                            {!action.dispatched && action.dispatchingRequired? <span className="notDispatched">(Not Dispatched)</span> : ''}</div>
                    }else{
                        return <div className="taskAction" key={index}>
                            <BsDot />
                            {`${action.title}${action.desc ? ': ' + action.desc : ' - '}${endingStringGenerator(action)}`}
                            {!action.dispatched && action.dispatchingRequired? <span className="notDispatched">(Not Informed)</span> : ''}
                            
                            </div>
                    }
                    
                })}
            </TaskBox>
        }) : null}
    </div>
}
function formattedAddress(address){
    const cityStateString = `${address.city ? address.city + ", " : ""}${address.state || ""}`;
    return address.companyName ? `${address.companyName} (${cityStateString})` : `${cityStateString}`
}
function endingStringGenerator(action){
    if(action.resetEndETA){
        return `Until ${action.resetEndETA}`;
    }else if(action.endingTimeType === "Plus"){
        return `Duration ${action.durationInDays} day(s)`
    }else if(action.endingTimeType === "Until"){
        return `Until ${action.endDate} ${action.endTime ||""}`
    }
    return "";
}